module.exports = __webpack_public_path__ + "static/media/galerija_2016 (1).4d79fc37.jpg";